/** Format-neutral Markdown building blocks shared by API description renderers. */
export { anchor, createDocumentAnchors } from '../document-anchors.js';
export { describe, field, heading, inlineCode, item, link, list, paragraph, strong, text } from '../markdown-nodes.js';
export { createDescriptionParser, expandDescriptions } from '../parse-description.js';
